/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NTPServer
 */
export interface NTPServer {
    /**
     * 
     * @type {number}
     * @memberof NTPServer
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof NTPServer
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof NTPServer
     */
    options?: string;
}

export function NTPServerFromJSON(json: any): NTPServer {
    return NTPServerFromJSONTyped(json, false);
}

export function NTPServerFromJSONTyped(json: any, ignoreDiscriminator: boolean): NTPServer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'address': json['address'],
        'options': !exists(json, 'options') ? undefined : json['options'],
    };
}

export function NTPServerToJSON(value?: NTPServer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'address': value.address,
        'options': value.options,
    };
}


